<template>
  <div class="page-loading" @scroll.prevent>
    <div class="page-loading-content" ref="pageLoading"></div>
  </div>
</template>
<script>
import lottie from 'lottie-web'
export default {
  name: 'page-loading',
  mounted () {
    lottie.loadAnimation({
      container: this.$refs.pageLoading,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'https://s.kcimg.cn/wap/font/lottie/page-loading.json' // 动画json的路径
    })
  }
}
</script>
<style scoped>
  .page-loading {
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .page-loading-content{
    height: 133px;
  }
</style>
